
<ejs-schedule
  #schedule
  [eventSettings]="eventSettings"
  [timeScale]="timeScale"
  [selectedDate]="selectedDate"
  [group]="group"
  [allowDragAndDrop]="true"
  [allowResizing]="true"
  [rowAutoHeight]="true"
  [showQuickInfo]="false"
  height="100%"
  width="100%"
  timeFormat="H:mm"
  (eventRendered)="onEventRendered($event)"
  (dragStart)="onDragStart($event)"
  (dragStop)="onDragStop($event)"
  (resizeStart)="onResizeStart($event)"
  (resizeStop)="onResizeStop($event)"
  (select)="onSelect($event)"
  (eventDoubleClick)="onEventDoubleClick($event)"
  (cellDoubleClick)="onCellDoubleClick($event)"
  (currentViewChange)="onCurrentViewChange($event)"
  (navigating)="onNavigating($event)"
  (click)="onSchedulerClick($event)"
  (cellClick)="onCellClick($event)"
  [class.loading-box.loading-box-opacity--slight]="fetchingLocationsData"
  [resourceHeaderTemplate]="groupHeaderTpl"
  >

  <e-views>
    <e-view option="TimelineWeek" [allowVirtualScrolling]="false" [enableLazyLoading]="false"></e-view>
    <e-view option="TimelineDay" [allowVirtualScrolling]="false" [enableLazyLoading]="false" isSelected=true></e-view>
  </e-views>

  <e-resources>
    <e-resource field="locationGroupId" title="Location Group" name="LocationGroups"
      [dataSource]="locationGroupsDataSource" [allowMultiple]="true" 
      textField='title' idField='id' expandedField='expanded' cssClassField="cssClass">
    </e-resource>

    <e-resource field="locationId" title="Location" name="Locations"
      [dataSource]="locationData" [allowMultiple]="true" 
      textField='title' idField='id' groupIDField="locationGroupId" colorField='color' >
    </e-resource>
  </e-resources>
</ejs-schedule>




<ng-template #groupHeaderTpl let-data>
  <div
    class="custom-resource-head"
    [ngbTooltip]="data.resource.name === 'LocationGroups' && data.resourceData.id !== TIMELINE_newLocationId && disableGroupHeaderTooltip === false ?
      (data.resourceData.expanded ? ('admin.location-picker.timeline.collapse.tooltip' | translate) : ('admin.location-picker.timeline.expand.tooltip' | translate))
      : null"
    container="body">
    
    @if (data.resource.name === 'LocationGroups') {
      @if (data.resourceData.id !== TIMELINE_newLocationId) {
        <i class="expand-icon pi {{ data.resourceData.expanded ? 'pi-chevron-down' : 'pi-chevron-right' }}"></i>
      }

      @if (data.resourceData.pinnable) {
        <span class="pin-wrap">
          @if (data.resourceData.pinned) {
            @if (data.resourceData.pinMovableDirections?.includes('up')) {
              <i
                (click)="onMovePin('up', data.resourceData.id, $event)"
                [ngbTooltip]="'admin.location-picker.timeline.move-pin-up.tooltip' | translate"
                container="body"
                (mouseenter)="disableGroupHeaderTooltip = true"
                (mouseleave)="disableGroupHeaderTooltip = false"
                class="pi pi-chevron-up pin-direction">
              </i>
            }
            @if (data.resourceData.pinMovableDirections?.includes('down')) {
              <i
                (click)="onMovePin('down', data.resourceData.id, $event)"
                [ngbTooltip]="'admin.location-picker.timeline.move-pin-down.tooltip' | translate"
                container="body"
                (mouseenter)="disableGroupHeaderTooltip = true"
                (mouseleave)="disableGroupHeaderTooltip = false"
                class="pi pi-chevron-down pin-direction">
              </i>
            }
          }
          
          <i
            (click)="onPin(data.resourceData.id, $event)"
            [ngbTooltip]="data.resourceData.pinned ? ('admin.location-picker.timeline.unpin.tooltip' | translate) : ('admin.location-picker.timeline.pin.tooltip' | translate)"
            container="body"
            (mouseenter)="disableGroupHeaderTooltip = true"
            (mouseleave)="disableGroupHeaderTooltip = false"
            class="pi pi-thumbtack pin"
            [class.pinned]="data.resourceData.pinned">
          </i>
        </span>
      }
    }
    <span class="custom-resource-head__title" [class.font-bold]="data.resource.name === 'LocationGroups'">
      {{ data.resourceData.title  }}
    </span>
  </div>
</ng-template>